import React from "react";
import { Container, Grid } from "@material-ui/core";
import HomePage from ".";
const VBienvenida = () => {
  return (
    <HomePage>
      <Container>
        <Grid container>
          <Grid item xs={12}>
            <div style={{textAlign: "center", margin: "40px", fontSize: "2rem"}}>
                Bienvenido
            </div>
          </Grid>
        </Grid>
      </Container>
    </HomePage>
  );
}
export default VBienvenida